import { render, staticRenderFns } from "./novo-usuario.vue?vue&type=template&id=3cfb426f"
import script from "./novo-usuario.vue?vue&type=script&lang=js"
export * from "./novo-usuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports